import { render, staticRenderFns } from "./NeedPhotoViewer.vue?vue&type=template&id=168c4537&scoped=true"
import script from "./NeedPhotoViewer.vue?vue&type=script&lang=js"
export * from "./NeedPhotoViewer.vue?vue&type=script&lang=js"
import style0 from "./NeedPhotoViewer.vue?vue&type=style&index=0&id=168c4537&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168c4537",
  null
  
)

export default component.exports